<!-- 设备列表页面 -->
<template>
  <div class="vcnDeviceList fire_truck_container">
    <!--主页面 -->
    <div class="flex-row"
         style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left">
        <el-scrollbar style="height: 100%">
          <el-tree :data="frame"
                   :props="treeProps"
                   class="shebeiDiv"
                   @node-click="currentChange"
                   :expand-on-click-node="true"
                   :default-expand-all="false"
                   :default-expanded-keys="['1']"
                   :highlight-current="true"
                   node-key="thirdDeviceId"
                   ref="vuetree"></el-tree>
        </el-scrollbar>
      </div>

      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 头部按钮 -->
        <div class="section-mian__toolbar">
          <el-button type="primary"
                     class="iss-operation-button"
                     icon="iconfont icon-iconfontfanhui"
                     @click="retBtn">返回</el-button>
          <el-button type="primary"
                     class="iss-operation-button"
                     icon="el-icon-plus"
                     v-auth="'/deviceaccess/index:addDevice'"
                     @click="add">新增</el-button>
          <el-button type="primary"
                     class="iss-operation-button"
                     icon="el-icon-delete"
                     v-auth="'/deviceaccess/index:deleteDevice'"
                     @click="batchDevice">批量删除</el-button>
        </div>
        <div class="section-main_table">
          <ioc-table ref="devTab"
                     :data="fireTruckData"
                     :option="deviceOption"
                     :page="devicePage"
                     @search-change="handleSearchChange"
                     @search-reset="resetForm"
                     @row-save="handleCreate"
                     @row-update="handleUpdate"
                     @current-change="selectPage"
                     @selection-change="selectionChange"
                     @size-change="changeSize">
            <!-- 定制操作栏按钮 -->
            <template slot="menu"
                      slot-scope="scope">
              <el-tooltip class="item"
                          effect="dark"
                          content="修改"
                          placement="top"
                          popper-class="tooltip-draw">
                <el-button type="text"
                           v-auth="'/deviceaccess/index:updateDevice'"
                           @click="update(scope.row)"
                           icon="iconfont icon-xiugai"></el-button>
              </el-tooltip>
              <el-tooltip class="item"
                          effect="dark"
                          :content="$t('deviceAccess.button.delete')"
                          placement="top"
                          popper-class="tooltip-draw">
                <el-button type="text"
                           v-auth="'/deviceaccess/index:deleteDevice'"
                           @click="delDevBtn(scope.row)"
                           icon="iconfont icon-shanchu"></el-button>
              </el-tooltip>

            </template>
          </ioc-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "../../api/index";
import { Dic } from "$utils";
import utils from '@src/common/utils'
import i18n from "@src/common/lib/i18n";
import { tableOption } from "../../config/fireTruckTable"
export default {
  filters: {
    // 子设备类型过滤
    deviceSubType: function (val) {
      switch (val) {
        case "2":
          return i18n.t("deviceAccess.label.cameradev");
        case "3":
          return i18n.t("deviceAccess.label.langdev");
        case "4":
          return i18n.t("deviceAccess.label.alarmdev");
      }
    },
  },
  data () {
    return {
      // 系统id
      systemId: "",
      platID: "",
      factoryId: "",
      systemName: "",
      deviceType: "",
      // 树的props
      treeProps: {
        label: "thirdDeviceName",
        children: "subDeviceList",
      },
      // 详情弹框
      dialogVisible: false,
      // 选中设备ID集合
      selDev: [],
      // 设备树的数据
      frame: [],
      // 树的节点值
      treeKey: "-1",
      // 设备ID
      deviceId: "",
      // 分页属性设置
      devicePage: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      level: "",
      fireTruckData: [],
      deviceOption: tableOption(this),
      rowInfo: {},
      // 查询字段
      queryForm: {
        plateNo: "",
        deviceName: "",
      },
    };
  },
  created () {
    this.systemId = this.$route.query.systemId;
    this.systemName = this.$route.query.systemName;
    this.platID = this.$route.query.platID;
    this.factoryId = this.$route.query.factoryId;
    this.deviceType = this.$route.query.deviceType;
  },
  mounted () {
    // 请求树根节点
    this.getAccessDeviceInfoTree();
    // 请求设备列表
    this.getFireTruckList();
  },
  methods: {
    // 返回按钮
    retBtn () {
      this.$router.go(-1);
    },
    getAccessDeviceInfoTree () {
      const params = {
        systemId: this.systemId,
      };
      this.$fetch(api.device.queryPlatSystemDeviceTree, params).then((res) => {
        if (res.success) {
          this.frame = [res.returnObj];
          this.$nextTick(() => {
            this.$refs.vuetree.setCurrentKey("-1");
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 树的子节点点击事件
    currentChange (data, node) {
      this.$log.info("树的子节点点击", data);
      this.treeKey = data.deviceID;
      this.level = node.level;
      if (this.level) {
        this.deviceId = data.deviceID;
      }
      this.getFireTruckList();
    },
    add () {
      this.$refs.devTab.rowAdd()
    },
    handleCreate (addInfo, done) {
      this.$refs['devTab'].$refs['form'].validate((valid) => {
        if (!valid) {
          return false
        } else {
          let params = {
            parentDeviceId: "200000010",
            parentDeviceIds: "200000010",
            systemId: 200000010,
            plateNo: addInfo.plateNo,
            thirdDeviceDesc: addInfo.thirdDeviceDesc,
            thirdDeviceId: addInfo.thirdDeviceId,
            thirdDeviceName: addInfo.deviceName
          }
          this.$fetch(api.fireTruck.addFireTruckDevice, params).then((res) => {
            if (res && res.success) {
              this.$message.success('新增成功')
              this.getFireTruckList()
            } else {
              this.$message.error(res.msgContent)
            }
            done()
          })
        }
      })
    },
    update (row) {
      this.rowInfo = { ...row }
      this.$refs.devTab.rowEdit(row)
    },
    handleUpdate (updateInfo, done) {
      this.$refs['devTab'].$refs['form'].validate((valid) => {
        if (!valid) {
          return false
        } else {
          let params = {
            deviceID: this.rowInfo.deviceID,
            plateNo: updateInfo.plateNo,
            thirdDeviceDesc: updateInfo.thirdDeviceDesc,
            thirdDeviceId: updateInfo.thirdDeviceId,
            thirdDeviceName: updateInfo.deviceName
          }
          this.$fetch(api.fireTruck.updateFireTruckDevice, params).then((res) => {
            if (res && res.success) {
              this.$message.success('修改成功')
              this.getFireTruckList()
            } else {
              this.$message.error(res.msgContent)
            }
            done()
          })
        }
      })
    },
    handleSearchChange (param) {
      console.log('param', param)
      this.queryForm = param
      this.getFireTruckList()
    },
    // 重置搜索
    resetForm () {
      this.queryForm = {
        plateNo: '',
        deviceName: ''
      }
      this.getFireTruckList()
    },
    // 根据树查询设备列表
    getFireTruckList () {
      const params = {
        deviceName: this.queryForm.deviceName,
        plateNo: this.queryForm.plateNo,
        systemId: this.systemId,
        thirdDeviceId: "",
        pageNum: this.devicePage.pageNum,
        pageSize: this.devicePage.pageSize,
      }
      this.$fetch(api.fireTruck.queryFireTruckDevice, params).then((res) => {
        if (res.success) {
          this.fireTruckData = res.returnObj.list;
          this.devicePage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },

    // 批量删除设备
    batchDevice () {
      if (this.selDev.length === 0) {
        this.$message.warning(this.$t("deviceAccess.message.deltips"));
        return;
      }
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.confirmDelete();
      });
    },
    // 单独删除设备
    delDevBtn (row) {
      this.selDev = [row.deviceID];
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.confirmDelete();
      });
    },
    // 确认删除
    confirmDelete () {
      this.devicePage.pageNum = 1;
      let params = { deviceIDList: this.selDev };
      this.$fetch(api.device.deletePlatSystemDevice, params).then((res) => {
        if (res.success == true) {
          this.$message.success(this.$t("deviceAccess.message.delsuccess"));
        } else {
          this.$message.error(this.$t("deviceAccess.message.delfail"));
        }
        this.getFireTruckList();
        this.$refs.devTab.selectClear();
      });
    },

    getDeviceDetail (row) {
      this.dialogVisible = true;
      const params = {
        deviceID: row.deviceID,
      };
      this.$fetch(api.device.queryPlatSystemDeviceDetail, params).then(
        (res) => {
          if (res.success) {
            this.devDtail = res.returnObj;
            this.devDtail.status = Dic.findByValue(
              "SENU015",
              res.returnObj.status
            );
          }
        }
      );
    },
    // 当选择项发生变化时会触发该事件
    selectionChange (selections) {
      let myAry = [];
      selections.map((item) => {
        myAry.push(item.deviceID);
      });
      this.selDev = myAry;
    },
    // 点击上一页下一页按钮
    selectPage (val) {
      this.devicePage.currentPage = val;
      this.queryFireTruckDevice()
    },
    // 修改每页数据数量
    changeSize (val) {
      this.devicePage.pageNum = 1;
      this.devicePage.pageSize = val;
      this.getFireTruckList();
    },
  },
};
</script>
<style lang="scss" scoped>
.vcnDeviceList {
  width: 100%;
  height: 100%;
  .section-main__warp {
    margin: 0 !important;
  }
}
</style>
<style lang="scss">
.fire_truck_container {
  .el-table__fixed-right-patch {
    display: none;
  }
}
</style>
